import { Component, OnInit, Inject } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { RopeShovelService } from '../../rope-shovel.service';
import { ReportConfigVM } from '../../models/rope-shovel.model';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-rs-report-config',
  templateUrl: './rs-report-config.component.html',
  styleUrls: ['./rs-report-config.component.scss']
})
export class rsreportconfigcomponent implements OnInit {
  
  inspectionId: number;
  
  ReportConfigList: ReportConfigVM[] = [];
  
  loading = false;

  constructor(private _dialogRef: MatDialogRef<rsreportconfigcomponent>,
    private _reportConfigService: RopeShovelService,
    private _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _notify: NotificationsService,
  private _fb: FormBuilder) { }

  ngOnInit() {
    this.inspectionId = this._data.inspectionId;
    this.getReportConfigData();
  }

  onCloseClick(): void {
    this._dialogRef.close(false);
  }

  getReportConfigData() {
    this.loading = true;
    this._reportConfigService.getReportConfigData(this.inspectionId).subscribe(res => {
      //console.log("component Types", res)
      this.ReportConfigList = res;
      //this.ReportCompartTypeList = this.ReportConfigList.filter((item, i, arr) => arr.findIndex((t) => t.Id === item.Id) === i)
      this.loading = false;
    },
      error => {
        console.error(error);
        this._notify.error('Error', 'Error while fetching Component Types.');
        this.loading = false;
      }
    );
  }

  toggleIncludes(Id: number, CompartTypeId: number, MiningShovelReportId: number, OptionType: string, SortOrder: number, event: MatCheckboxChange) {
    //console.log(event.checked);
    this.loading = true;
    let params = new ReportConfigVM();
    params.Id = Id;
    params.CompartTypeId = CompartTypeId;
    params.MiningShovelReportId = MiningShovelReportId;
    params.OptionType = OptionType;
    params.OptionTypeChecked = event.checked;
    params.InspectionId = this.inspectionId;
    params.SortOrder = SortOrder;
    this._reportConfigService.setReportConfigData(params).subscribe(res => {
      if (res) {
        this.getReportConfigData();
      }
    });
  }

  recalculateSortOrder(configId: number, miningShovelReportId: number, sortOrder: number, incrementOrder: number) {
    this.loading = true;
    this._reportConfigService.recalculateSortOrder(configId, miningShovelReportId, sortOrder, incrementOrder).subscribe(res => {
      if (res == true) {
        this.getReportConfigData();
      }
    })
  }


}
